import { FundriseRouteConfig } from 'vue-router';

const vcxRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/vcx',
		name: 'vcx-landing',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/vcx/vcx-landing-view.vue')
	},
	{
		path: `/vcx/newsroom`,
		name: 'vcx-newsroom',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: { name: 'blog-category', params: { categoryUrlSlug: 'vcx' } }
	},
	{
		path: `/vcx/newsroom/:blogPostUrlSlug`,
		name: 'vcx-blog-post',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/vcx/vcx-article-view.vue')
	}
];

export default vcxRoutes;
